import { Row, Col } from "react-bootstrap";
import { User } from "./interfaces/User";
import UserCard from "./UserCard";

interface UserGridProps {
  users: User[];
  isLoading?: boolean;
}

export default function UserGrid({ users, isLoading = false }: UserGridProps) {
  if (isLoading && users.length === 0) {
    return (
      <Row className="justify-content-center">
        <Col className="text-center py-5">
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </Col>
      </Row>
    );
  }

  return (
    <Row xs={1} md={2} lg={3} xl={4} className="g-4">
      {users.map((user, index) => (
        <Col key={user.uid || index}>
          <UserCard user={user} />
        </Col>
      ))}
    </Row>
  );
}